import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8">
        <div className="mb-8">
          <Link to="/" className="text-[#0EA5E9] hover:text-[#0284c7] text-sm font-medium">
            ← Back to PassportTalk
          </Link>
        </div>
        
        <h1 className="text-4xl font-bold text-travel-navy font-outfit mb-4">Privacy Policy</h1>
        <p className="text-sm text-slate-600 mb-8">
          <strong>Effective Date:</strong> January 1, 2025<br />
          <strong>Last Updated:</strong> January 5, 2025
        </p>

        <div className="prose prose-slate max-w-none">
          <h2>Introduction</h2>
          <p>
            Your privacy is important to us. This Privacy Policy explains how PassportTalk collects, uses, shares, and protects your personal information.
          </p>
          <p>
            By using PassportTalk, you consent to the data practices described in this policy.
          </p>

          <h2>1. Information We Collect</h2>
          <h3>1.1 Account Information</h3>
          <p>When you register:</p>
          <ul>
            <li>Email address (required)</li>
            <li>Full name (required)</li>
            <li>Password (encrypted)</li>
            <li>Account type (Traveler, Agent, Admin)</li>
          </ul>

          <h3>1.2 Translation Data</h3>
          <ul>
            <li>Text you translate (source and target)</li>
            <li>Language pairs used</li>
            <li>Scenario selections</li>
            <li>Translation timestamps</li>
            <li>Audio playback activity</li>
          </ul>

          <h3>1.3 Call Data</h3>
          <ul>
            <li>Call duration and timestamps</li>
            <li>Agent selected</li>
            <li>Call status (connected, failed, completed)</li>
            <li>Call ratings and feedback</li>
            <li><strong>Note:</strong> Call audio may be recorded for quality assurance</li>
          </ul>

          <h3>1.4 Payment Information</h3>
          <ul>
            <li>Payment method details (stored by Stripe, not us)</li>
            <li>Transaction history</li>
            <li>Billing amounts and dates</li>
            <li>We receive only transaction confirmations, not full card details</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <h3>2.1 Provide Services</h3>
          <ul>
            <li>Process translations via AI</li>
            <li>Connect you with available agents</li>
            <li>Route WhatsApp calls</li>
            <li>Process payments</li>
            <li>Save your favorites and history</li>
          </ul>

          <h3>2.2 Improve Services</h3>
          <ul>
            <li>Analyze usage patterns</li>
            <li>Identify and fix bugs</li>
            <li>Develop new features</li>
            <li>Train and improve AI models</li>
            <li>Optimize user experience</li>
          </ul>

          <h3>2.3 Beta Program</h3>
          <div className="bg-[#0EA5E9]/10 border border-[#0EA5E9]/20 rounded-lg p-4 my-4">
            <p className="text-sm">During beta, we collect additional usage data to:</p>
            <ul className="text-sm mt-2">
              <li>Monitor feature adoption</li>
              <li>Gather user feedback</li>
              <li>Test new features</li>
              <li>Assess system performance</li>
            </ul>
          </div>

          <h2>3. Information Sharing</h2>
          <p className="font-semibold">We do NOT sell your personal data.</p>

          <h3>3.1 Service Providers</h3>
          <p>We share data with:</p>
          <ul>
            <li><strong>Gemini (Google AI):</strong> Translation text and context for AI translation service</li>
            <li><strong>Twilio:</strong> Agent WhatsApp numbers and call data for calling service</li>
            <li><strong>Stripe:</strong> Payment information for payment processing</li>
            <li><strong>Emergent:</strong> All application data for platform hosting</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>We implement:</p>
          <ul>
            <li><strong>Encryption:</strong> HTTPS for all communications</li>
            <li><strong>Authentication:</strong> JWT tokens with secure hashing</li>
            <li><strong>Access Control:</strong> Role-based permissions</li>
            <li><strong>Password Protection:</strong> Bcrypt hashing</li>
            <li><strong>Secure Storage:</strong> Encrypted databases</li>
          </ul>

          <h2>5. Your Rights</h2>
          <h3>5.1 Access and Portability</h3>
          <p>You can:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Export your translation history</li>
            <li>Download your account information</li>
          </ul>
          <p>Request via: privacy@passtalkapp.com</p>

          <h3>5.2 Deletion</h3>
          <p>You can request:</p>
          <ul>
            <li>Account deletion</li>
            <li>Specific data removal</li>
            <li>Translation history clearing</li>
          </ul>
          <p>Processed within 30 days. Some data retained per legal requirements.</p>

          <h2>6. Contact Us</h2>
          <p><strong>Privacy Questions:</strong></p>
          <ul className="list-none">
            <li><strong>Email:</strong> privacy@passtalkapp.com</li>
            <li><strong>Website:</strong> https://passtalkapp.com/privacy</li>
          </ul>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <p className="text-sm text-slate-600 text-center">
            <strong>Last Updated:</strong> January 5, 2025 | <strong>Version:</strong> 1.0 (Beta)
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;